export default __webpack_public_path__ + "static/media/copyicon.d419fc76.svg";